import React, {  useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, CircularProgress, withStyles } from "@material-ui/core";
import { TooltipTop } from "../../../../Common/CustomTooltips";
import t from "../../../../../languages/pl";
import ConfirmationCarActionDialog from "./ConfirmationCarActionDialog";

const useStyles = theme => ({
  actionButton: {
    margin: theme.spacing(2),
    color: "#FFF",
    background: "#C9C8C8FF"
  },
  wrapper: {
    position: "relative"
  },
  buttonPending: {
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  }
});

const modeStatus = {
  OFF: 0,
  ON: 1,
  PENDING: 2,
  NOT_CONNECTED: 3
};

const getButtonLabel = (value, turnOn = t.turnOn, turnOff = t.turnOff) => {
  switch (value) {
    case modeStatus.OFF:
      return turnOn;
    case modeStatus.ON:
      return turnOff;
    case modeStatus.NOT_CONNECTED:
      return t.deviceNotConnected;
    default:
      return t.statusPending;
  }
};

const SmsModeButton = props => {
  const {
    classes,
    actionText,
    name,
    onLabel,
    offLabel,
    gpsState,
    background,
    tooltipTitle,
    value,
    onClick,
    isDisabled
  } = props;

  const [isPending, setIsPending] = useState(false);
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const isKnownState = value === modeStatus.OFF || value === modeStatus.ON;
  const showPending = isPending || value === modeStatus.PENDING;

  // Any fresh value from the server ends the pending state
  useEffect(() => {
    setIsPending(false);
  }, [value]);

  const handleConfirmationSubmit = () => {
    setIsPending(true);
    setIsConfirmationOpen(false);
    onClick && onClick(value === modeStatus.ON ? modeStatus.OFF : modeStatus.ON);
  };

  return (
    <React.Fragment>
      <div className={classes.wrapper}>
        <TooltipTop title={tooltipTitle}>
          <div>
            <Button
              variant="contained"
              name={name}
              classes={{
                root: classes.actionButton,
              }}
              style={{ background: background }}
              disabled={isDisabled || showPending || !isKnownState}
              onClick={() => setIsConfirmationOpen(true)}
            >
              {showPending ? t.statusPending : getButtonLabel(value, onLabel, offLabel)}
            </Button>
          </div>
        </TooltipTop>
        {showPending && <CircularProgress size={24} className={classes.buttonPending}/>}
      </div>
      <ConfirmationCarActionDialog
        name={name}
        gpsState={gpsState}
        action={t.change + " " + actionText}
        open={isConfirmationOpen}
        onClose={() => setIsConfirmationOpen(false)}
        onSubmit={handleConfirmationSubmit}
      />
    </React.Fragment>
  );
};

SmsModeButton.propTypes = {
  classes: PropTypes.object,
  actionText: PropTypes.string,
  onLabel: PropTypes.string,
  offLabel: PropTypes.string,
  isDisabled: PropTypes.bool,
  gpsState: PropTypes.string,
  name: PropTypes.string,
  background: PropTypes.string,
  tooltipTitle: PropTypes.string,
  value: PropTypes.number,
  onClick: PropTypes.func
};

export default withStyles(useStyles)(SmsModeButton);
